import(/* webpackMode: "eager" */ "/app/apps/portal-play/src/app/(app)/error.tsx")